import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import { Body1, H1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

export const ScrollView = styled.ScrollView.attrs({
  contentContainerStyle: {
    padding,
    flexGrow: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
})``;

export const Title = styled(H1)`
  text-align: center;
`;

export const Content = styled(Body1)`
  text-align: center;
`;

export const UnlinkIcon = styled(FontIcon).attrs(({ theme }) => ({
  color: theme.colors.primary,
  size: 64,
  name: 'unlink',
}))``;
